
import {useHead} from '@vueuse/head'
import StockDashboard from "./stratlist/stratslistDash.vue"
import SidebarLayout from '../layouts/SidebarLayout.vue'
import {computed, defineComponent, reactive} from "vue";

import VButton from '../components/base/button/VButton.vue'
import {useToggle} from '@vueuse/core'
import store, {ActionTypes} from "../store";
import {mapState} from "vuex";

export default defineComponent({
  name: 'Login',
  components: {
    VButton,
    StockDashboard,
    SidebarLayout
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() =>
        store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() => next())
    )
  },
  beforeRouteUpdate(to, from, next) {
    store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() =>
        store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() => next())
    )
  },
  setup() {
    const siteData = reactive({
      title: `JB Drax Honoré Strategies`
    })
    useHead({
// Can be static or computed
      title: computed(() => siteData.title),
    })
    useToggle(false)
//pageTitle.value=ref('JB Drax Honoré Login')

  },
  computed: {
    ...mapState(['user'])
  },


})


